import { NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ButtonModule } from '@coreui/angular-pro';

export interface GenericModalData {
  title: string;
  body: string;
  cancelBtnText?: string;
  okBtnText?: string;
  showOnlyAccept?: boolean
  showCloseButton?: boolean;
}

@Component({
  selector: 'app-generic-modal',
  standalone: true,
  imports: [NgIf, MatDialogModule, ButtonModule],
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.scss'],
})
export class GenericModalComponent {
  constructor(
    public dialogRef: MatDialogRef<GenericModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GenericModalData
  ) { }
}
